import { render } from "./LavadosChart.vue?vue&type=template&id=f76fb0e4&scoped=true"
import script from "./LavadosChart.vue?vue&type=script&lang=js"
export * from "./LavadosChart.vue?vue&type=script&lang=js"

import "./LavadosChart.vue?vue&type=style&index=0&id=f76fb0e4&scoped=true&lang=css"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f76fb0e4"]])

export default __exports__